import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomMoldedRubberProductsComponent } from './custom-molded-rubber-products.component';

const routes: Routes = [
  {
    path: '',
    component: CustomMoldedRubberProductsComponent,
    data: {
      meta: {
        title: 'Custom Molded Rubber | Marco Sealing Solutions',
        description: 'Custom molded rubber products and assemblies from Marco Sealing Solutions (formerly Marco Rubber & Plastics)'
      }
    }
  }
];
export const routerModuleForChild = RouterModule.forChild(routes)

@NgModule({
  imports: [routerModuleForChild],
  exports: [RouterModule]
})
export class CustomMoldedRubberProductsRoutingModule { }
